// extracted by mini-css-extract-plugin
export default {"image":"background__image__JTnQs","color":"background__color__W0Y4g","video":"background__video__ztjD1","videoEnabled":"background__videoEnabled__jV09l"};